import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '@/i18n'
import Home from '../components/Home'

Vue.use(VueRouter)
const { locale } = i18n;

const routes = [
    {
        path: '*',
        redirect: `/${i18n.locale}`
    },
    {
    path: '/:locale',
    component: {
        render: h => h('router-view')
    },
    beforeEnter: async (to, from, next) => {
        const supported_locales = await process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',');
        if (!supported_locales.includes(locale)) return next(i18n.locale);
        if (i18n.locale !== locale) {
            i18n.locale = locale;
        }
        return next()
    },
    children: [
        {
            path: '',
            name: 'Home',
            component: Home,
            meta: {
                title: "Home page | Fiber blowing Machines",
                description: "Discover top-quality fiber blowing machines for efficient fiber optic installation. Explore our range of innovative solutions for the telecom industry.",
                image: "/home-image.jpg"
            }
        },
        {
            path: 'multi',
            name: 'MultiTank',
            component: () => import('../components/MultiTank'),
            meta: {
                title: "MultiTank | Fiber blowing Machines",
                description: "Discover top-quality fiber blowing machines for efficient fiber optic installation. Explore our range of innovative solutions for the telecom industry.",
                image: "/multitank-image.jpg"
            }
        },
        {
            path: 'ftth_one',
            name: 'FtthOne',
            component: () => import( '../components/FTTHOne'),
            meta: {
                title: "Ftth One | Fiber blowing Machines",
                description: "Discover top-quality fiber blowing machines for efficient fiber optic installation. Explore our range of innovative solutions for the telecom industry.",
                image: "/home-image.jpg"
            }
        },
        {
            path: 'micro_typhoon',
            name: 'MicroTyphoon',
            component: () => import( '../components/MicroTyphoon'),
            meta: {
                title: "MicroTyphoon | Fiber blowing Machines",
                description: "Discover top-quality fiber blowing machines for efficient fiber optic installation. Explore our range of innovative solutions for the telecom industry.",
                image: "/home-image.jpg"
            }
        },
        {
            path: 'typhoon_32',
            name: 'Typhoon32',
            component: () => import('../components/Typhoon32'),
            meta: {
                title: "Typhoon 32 | Fiber blowing Machines",
                description: "Discover top-quality fiber blowing machines for efficient fiber optic installation. Explore our range of innovative solutions for the telecom industry.",
                image: "/home-image.jpg"
            }
        },
        {
            path: 'typhoon_50',
            name: 'Typhoon50',
            component: () => import('../components/Typhoon50'),
            meta: {
                title: "Typhoon 50 | Fiber blowing Machines",
                description: "Discover top-quality fiber blowing machines for efficient fiber optic installation. Explore our range of innovative solutions for the telecom industry.",
                image: "/home-image.jpg"
            }
        },
        {
            path: 'y_2',
            name: 'Y2',
            component: () => import('../components/Y2'),
            meta: {
                title: "Y2 | Fiber blowing Machines",
                description: "Discover top-quality fiber blowing machines for efficient fiber optic installation. Explore our range of innovative solutions for the telecom industry.",
                image: "/home-image.jpg"
            }
        },
        {
            path: 'download',
            name: 'Download',
            component: () => import('../components/Download'),
            meta: {
                title: "Download Technical Materials | Fiber Blowing Machines",
                description: "Access and download technical materials, manuals, and product specifications for our advanced fiber blowing machines. Get all the information you need for installation and maintenance.",
                image: "/download-image.jpg"
            }
        }
    ],
}
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }
        if (to.hash) {
            return { selector: to.hash }
        }
        return { x: 0, y: 0 }
    }
})



export default router
